import React, { useEffect } from "react";
import "./App.css";
import { useBeamXRAuth } from "./auth/useBeamXRAuth";
import AuthLoading from "./components/AuthLoading";
import { MeProvider } from "./context/MeContext";
import RoutedApp from "./RoutedApp";
import { OrganisationConfirmProvider } from "./context/OrganisationConfirmContext";

function App() {
  const { isLoading, isAuthenticated, signIn, error } = useBeamXRAuth();

  useEffect(() => {
    if (!isLoading && !isAuthenticated && !error) {
      signIn(); // Redirect to login if not authenticated
    }
    // error is in the dependency list so a failed sign in does not immediately retry.
  }, [isLoading, isAuthenticated, error, signIn]);

  if (isLoading) {
    return <AuthLoading message="Loading your developer experience" />; // Show a loading page while auth is being checked
  }

  if (error) {
    return <div>Oops... {error.message}</div>; // Show an error
  }

  if (!isAuthenticated) {
    return null; // Return nothing if the user is being redirected
  }

  return (
    <MeProvider>
      <OrganisationConfirmProvider>
        <RoutedApp />
      </OrganisationConfirmProvider>
    </MeProvider>
  );
}

export default App;
